export const bankEndpoints = (builder) => ({
    getBanks: builder.query({
        query: _ => ({url: `/banks`, method: 'get'}),
        providesTags: ['Banks'],
    }),
    updateBank: builder.mutation({
        query: ({ref, ...bank}) => ({url: `/banks/${ref}`, method: 'patch', body: bank}),
        invalidatesTags: ['Banks'],
    }),
    createBank: builder.mutation({
        query: (bank) => ({url: `/banks`, method: 'post', body: bank}),
        invalidatesTags: ['Banks'],
    }),
    deleteBank: builder.mutation({
        query: ({ref, ...bank}) => ({url: `/banks/${ref}`, method: 'delete', body: bank}),
        invalidatesTags: ['Banks'],
    }),
})